

























































import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import 'vue2-datepicker/index.css'
import Icon from '@/components/Icon.vue'
import { Debounce } from 'vue-debounce-decorator'
import moment from 'moment'

const DateRangePicker = require('vue2-datepicker').default

@Component({
  props: {
    dateFrom: {},
    dateTo: {},
    inline: {
      default: false
    },
    format: {
      default: 'MM/DD/YYYY'
    },
    type: {
      default: ''
    },
    value: {
      type: [String, Date]
    },
    shortcuts: {},
    validation: {
      type: String
    },
    trimIdentical: {
      type: Boolean,
      default: false
    },
    appendToBody: {
      type: Boolean,
      default: true
    }
  },
  components: {
    Icon,
    DateRangePicker
  }
})

export default class InputDateRangePicker extends Vue {
  isError: boolean = false
  date: Date [] | string [] = ['', '']

  disabledDates: any = {}

  get defaultValue () {
    return moment().subtract(0, 'year').format('YYYY-MM-DD')
  }

  @Debounce(100)
  emitInput (value: any) {
    this.$emit('input', value)
    if (this.$props.validation) {
      this.validate(value)
    }
  }

  @Watch('date', { deep: true })
  validate (value: any) {
    switch (this.$props.validation) {
      case 'required':
        this.validateRequired(value)
        break
    }
  }

  get rangeValue () {
    const [dateFrom, dateTo] = this.date
    if (!dateFrom || dateFrom === 'Invalid date') {
      return ''
    }
    if (this.$props.trimIdentical && dateFrom === dateTo) {
      return dateFrom
    }
    return dateFrom + '-' + dateTo
  }

  validateRequired (value: any) {
    if (!value || value.length === 0) {
      this.isError = true
    } else if (typeof value[0] === 'string') {
      this.isError = !value[0].length || value[1].length
    } else {
      this.isError = false
    }
  }

  mounted () {
    const dateFrom: Date | string = moment(this.$props.dateFrom).format(this.$props.format)
    const dateTo: Date | string = moment(this.$props.dateTo).format(this.$props.format)
    if (dateFrom) {
      this.date = [dateFrom, dateTo]
    }
    // @ts-ignore
    this.validate(this.date[0])
  }

  handleInput (event: any) {
    const value = event.target.value
    const dateRegExp = '(1[0-2]|0[1-9])/(3[01]|[12][0-9]|0[1-9])/\\d{4}'
    const dateRangeRegExp = new RegExp(`${dateRegExp}-${dateRegExp}`, 'g')
    if (dateRangeRegExp.test(value)) {
      const val = value.split('-')
      this.date = val
      this.emitInput(val)
    }
  }

  close () {
    // @ts-ignore
    this.$refs['dateRangePicker'].closePopup()
  }
}

